import React, { useState, useEffect } from 'react';
import { fetchClientsOverdueInvoices } from '../../services/api';
import './clientReminderComponent.css';

export default function ClientReminderComponent({ onClose, onConfirm }) {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedData = await fetchClientsOverdueInvoices();
        if (fetchedData) {
          const clients = fetchedData;
          const extractedData = clients.map(client => ({
            ...client,
            selected: false,
          }));
          setClients(extractedData);
        } else {
          setClients([]);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
        setClients([]);
      }
    };

    fetchData();
  }, []);

  const handleSelectAll = () => {
    setClients(clients.map(client => ({ ...client, selected: true })));
  };

  const handleDeselectAll = () => {
    setClients(clients.map(client => ({ ...client, selected: false })));
  };

  const handleToggleSelect = index => {
    const newClients = [...clients];
    newClients[index].selected = !newClients[index].selected;
    setClients(newClients);
  };

  const onTriggerConfirm = () => {
    const selected = clients.filter(client => client.selected).map(client => client.client_code);

    onConfirm(selected);
  };

  return (
    <div className="overlay">
      <div className="client-reminder-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <div className="client-reminder-list">
          <div className="client-reminder-select-all-buttons">
            <button type="button" onClick={handleSelectAll}>
              Tout sélectionner
            </button>
            <button type="button" onClick={handleDeselectAll}>
              Tout désélectionner
            </button>
          </div>
          <div className="shipments-list client-reminder">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Client</th>
                  <th>Nb factures échues</th>
                </tr>
              </thead>
              <tbody>
                {clients.map((client, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={client.selected}
                        onChange={() => handleToggleSelect(index)}
                      />
                    </td>
                    <td onClick={() => handleToggleSelect(index)}>{client.client_code}</td>
                    <td onClick={() => handleToggleSelect(index)}>
                      {client.overdue_invoices_count}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <button type="button" onClick={onTriggerConfirm}>
              Envoyer les relances
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
